import { render, staticRenderFns } from "./UpdatePasswordViaLinkPage.vue?vue&type=template&id=8f6ffd3e&scoped=true&"
import script from "./UpdatePasswordViaLinkPage.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordViaLinkPage.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePasswordViaLinkPage.vue?vue&type=style&index=0&id=8f6ffd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6ffd3e",
  null
  
)

export default component.exports